<template>
  <div
    class="field"
    :style="{ '--form-item-width': grid.Cols, '--form-item-height': grid.Rows, '--form-item-start': grid.Offset }"
  >
    <p v-if="value">{{ value }}</p>
  </div>
</template>

<script>
export default {
  name: 'field-description',
  props: {
    grid: Object,
    id: String,
    value: String
  }
}
</script>

<style scoped></style>
